import { render } from "./ComponentRender.vue?vue&type=template&id=50507202"
import script from "./ComponentRender.vue?vue&type=script&lang=js"
export * from "./ComponentRender.vue?vue&type=script&lang=js"

import "./ComponentRender.vue?vue&type=style&index=0&id=50507202&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__